/**
 * 플레이어 화면 구현
 */
import { SbsPlayerGlobal } from '../../../common';
import { clamp } from '../../../utils';
import {
  loadLocalStorage,
  saveLocalStorage,
  removeLocalStorage,
} from '../../../utils/storage';

import SbsPlayerLogger from '../../../utils/logger';

import './Center';
import './Controls';
import './Motion';
import './SubtitleDisplay';
import './Toast';
import './Video';

customElements.define(
  'sbs-player-wrapper',
  class extends HTMLElement {
    constructor() {
      super();
      this.state = {
        rscuse: null,
        cc: false,
        dvr: false,
        on_subtitle: false,
        on_audio_desc: false,
        motion: null,
        count: null,
      };
      this.hlsDisposed = false;
      // FIXME: [플레이어] 슬로우모션 기능 끄지 않은 상태에서 이탈 시 초기화
      this.playbackRate = 1;
      // this.playbackRate =
      //   SbsPlayerGlobal.target !== 'live' && !SbsPlayerGlobal.state.is_mobile
      //     ? loadLocalStorage(SbsPlayerGlobal.storage.sbsplayer_playback_rate) ||
      //       1
      //     : 1;
      this.shownFoundationMessage = false;
    }

    async connectedCallback() {
      try {
        this.render();
      } catch (error) {
        console.log(error);
      }
    }

    disconnectedCallback() {
      try {
        if (!document.body.contains(this)) {
        }
      } catch (error) {
        console.log(error);
      }
    }

    render() {
      try {
        const { source } = SbsPlayerGlobal.state.data;
        let mediaUrl =
          SbsPlayerGlobal.src ||
          source.mediasource.mediaurl?.replace('http://', 'https://');
        let subtitleUrl =
          source && source.subtitle
            ? source.subtitle.replace('http://', 'https://')
            : undefined;

        this.innerHTML = `<div class="playerVideo_w">
          <sbs-player-video-motion motion=${this.state.motion} count=${
          this.state.count
        }></sbs-player-video-motion>
          <div class="playerVideoCont">
            <sbs-player-video src="${mediaUrl}" track="${subtitleUrl}"></sbs-player-video>
          </div>
          <sbs-player-center-buttons style="display: none;"></sbs-player-center-buttons>
          ${
            SbsPlayerGlobal.target === 'live'
              ? `<sbs-player-timeshift-center></sbs-player-timeshift-center>`
              : ``
          }
        </div>
        ${subtitleUrl ? `<sbs-player-subtitle></sbs-player-subtitle>` : ``}
        <sbs-player-controls></sbs-player-controls>
        ${
          source && source.toast
            ? `<sbs-player-toast duration="${
                source.toast.duration
                  ? source.toast.duration
                  : SbsPlayerGlobal.options.toast_seconds
              }"></sbs-player-toast>`
            : ``
        }`;
        this.event();
        this.styles();
      } catch (error) {
        console.log(error);
      }
    }

    adjustVolume(video) {
      try {
        setTimeout(() => {
          let volume = loadLocalStorage(
            SbsPlayerGlobal.storage.sbsplayer_volume
          );
          if (!volume) volume = 0.5;
          video.volume = clamp(volume, 0, 1);
        }, 500);
      } catch (error) {
        console.error(error);
      }
    }

    /**
      * 
      * @param {string} rscuse 02, 05, 07 화질
      * @param {boolean} cc 라이브 자막 활성화 여부
      * @param {boolean} dvr 라이브 타임머신 활성화 여부

      * @return {*} 
      */
    request = async (rscuse, cc, dvr) => {
      const videoElement = this.querySelector('sbs-player-video');
      let url = SbsPlayerGlobal.url.info;
      url.searchParams.set('rscuse', rscuse ? rscuse : '');

      let fetchOptions = {};
      if (document.cookie === '') {
        fetchOptions = {
          method: 'GET',
        };
      } else {
        fetchOptions = {
          method: 'GET',
          credentials: 'include',
        };
      }
      let response = await fetch(`${url}`, fetchOptions);

      if (response.status === 200) {
        response = await response.json();
        SbsPlayerGlobal.state.data =
          response.vod || response.clip || response.onair;

        let { info, source, login_info } = SbsPlayerGlobal.state.data;

        // * sbsplayer_rscuse
        // * S회원일 경우 변경된 화질정보 저장
        if (login_info.is_s_member) {
          saveLocalStorage(SbsPlayerGlobal.storage.sbsplayer_rscuse, rscuse);
        } else {
          removeLocalStorage(SbsPlayerGlobal.storage.sbsplayer_rscuse);
        }

        // * 온에어 헬스체크 info
        if (info.onair_yn === 'N') {
          // alert(info.onair_text);
          SbsPlayerGlobal.view.querySelector(
            '.playerWrap'
          ).innerHTML = `<sbs-player-warning title="영상시청안내" html="${info.onair_text}"></sbs-player-warning>`;
          return false;
        } else if (info.overseas_yn === 'N') {
          // alert(info.overseas_text);
          SbsPlayerGlobal.view.querySelector(
            '.playerWrap'
          ).innerHTML = `<sbs-player-warning title="영상시청안내" html="${info.overseas_text}"></sbs-player-warning>`;
          return false;
        }

        let mediaUrl = source.mediasource.mediaurl.replace(
          'http://',
          'https://'
        );

        let subtitleUrl = source.subtitle?.replace('http://', 'https://');
        SbsPlayerGlobal.logModule.init(videoElement);

        if (cc) {
          if (info.caption_yn !== 'Y') {
            // LIVE
            alert('자막을 지원하지 않는 채널 입니다.');
          } else {
            mediaUrl = source.captionurl.replace('http://', 'https://');
          }
        } else if (dvr) {
          mediaUrl += '&DVR';
          // FIXME: TEST
          // mediaUrl =
          //   'https://dvrtest.sbs.co.kr/sbstest/_definst_/test.stream/playlist.m3u8?DVR';
        }

        return { media: mediaUrl, subtitle: subtitleUrl };
      } else {
        throw new Error('화질변경 오류');
      }
    };

    event() {
      try {
        let { source } = SbsPlayerGlobal.state.data;
        const videoElement = this.querySelector('sbs-player-video');
        const centerElement = this.querySelector('sbs-player-center-buttons');
        const controlElement = this.querySelector('sbs-player-controls');
        const motionElement = this.querySelector('sbs-player-video-motion');
        const qaulityMenuElement = controlElement.querySelector(
          'sbs-player-quality-menu'
        );

        // * live default mode (hls) 일때 pause 가 아니라 그냥 끊어야함
        centerElement.addEventListener('button-toggle-playpause', (event) => {
          let paused = videoElement.video.paused;
          if (SbsPlayerGlobal.target === 'live' && this.state.dvr) {
            paused ? videoElement.video.play() : videoElement.video.pause();
          } else {
            paused ? this.play() : this.pause();
          }

          //try {
          //  SbsPlayerGlobal.logModule.click('플레이어', 'NC', '', info.program.programtitle);
          //} catch (error) {
          //}
        });
        centerElement.addEventListener('button-click-replay', (event) => {
          videoElement.video.currentTime = 0;
          videoElement.video.play();
        });
        centerElement.addEventListener('button-click-backward', (event) => {
          videoElement.video.currentTime = clamp(
            videoElement.video.currentTime - 10,
            0,
            videoElement.video.duration - 0.05
          );
        });
        centerElement.addEventListener('button-click-forward', (event) => {
          videoElement.video.currentTime = clamp(
            videoElement.video.currentTime + 10,
            0,
            videoElement.video.duration - 0.05
          );
        });
        controlElement.addEventListener('button-click-popup', (event) => {
          this.pause();

          SbsPlayerGlobal.events.emitEvent('button-click-popup');
        });

        controlElement.addEventListener('progress-click', (event) => {
          videoElement.video.currentTime =
            videoElement.video.duration * event.detail;
        });
        controlElement.addEventListener('button-toggle-playpause', (event) => {
          let paused = event.detail;
          if (SbsPlayerGlobal.target === 'live' && this.state.dvr) {
            paused ? videoElement.video.play() : videoElement.video.pause();
          } else {
            paused ? this.play() : this.pause();
          }
        });
        controlElement.addEventListener('button-click-replay', (event) => {
          videoElement.video.currentTime = 0;
          videoElement.video.play();
        });
        controlElement.addEventListener('button-toggle-volume', (event) => {
          let muted = event.detail;
          videoElement.video.volume = muted ? 0.5 : 0;
        });
        controlElement.addEventListener('button-toggle-fullscreen', (event) => {
          this.dispatchEvent(
            new CustomEvent('button-toggle-fullscreen', {
              detail: event.detail,
            })
          );
        });
        controlElement.addEventListener('button-toggle-live-dvr', (event) => {
          this.dispatchEvent(
            new CustomEvent('button-toggle-live-dvr', { detail: event.detail })
          );
        });

        controlElement.addEventListener('timeshift-change-text', (event) => {
          // * LIVE DVR 시크바 이동시 중앙에 구간정보 노출
          centerElement.querySelector('.playerVideoBtns').style.display =
            event.detail ? 'none' : 'flex';
          centerElement
            .querySelector('sbs-player-center-timeshift-text')
            .setAttribute('text', event.detail);
        });

        // ? 오디오해설, CC에서 화질선택에 관련된 시나리오 필요...

        controlElement.addEventListener('button-toggle-subtitle', (event) => {
          try {
            if (source.subtitle) {
              this.state.on_subtitle = event.detail;
              const videoElement = this.querySelector('sbs-player-video');
              const subtitleElement = this.querySelector('sbs-player-subtitle');
              if (this.state.on_subtitle) {
                saveLocalStorage(
                  SbsPlayerGlobal.storage.sbsplayer_subtitle,
                  true
                );
                SbsPlayerGlobal.state.is_mobile
                  ? videoElement.showTrack()
                  : subtitleElement.setAttribute('showing', true);
              } else {
                saveLocalStorage(
                  SbsPlayerGlobal.storage.sbsplayer_subtitle,
                  false
                );
                SbsPlayerGlobal.state.is_mobile
                  ? videoElement.hideTrack()
                  : subtitleElement.setAttribute('showing', false);
              }
              this.toastSubtitleSupport();
            }
          } catch (error) {
            console.log(error);
          }
        });
        controlElement.addEventListener('subtitle-size-change', (event) => {
          try {
            const subtitleElement = this.querySelector('sbs-player-subtitle');
            subtitleElement.setAttribute('size', event.detail);
          } catch (error) {
            console.log(error);
          }
        });
        controlElement.addEventListener('button-toggle-audiodesc', (event) => {
          try {
            if (source.audio_description_url) {
              this.state.on_audio_desc = event.detail;
              saveLocalStorage(
                SbsPlayerGlobal.storage.sbsplayer_audiodesc,
                event.detail
              );

              videoElement.loadSource(
                this.state.on_audio_desc
                  ? source.audio_description_url.replace('http://', 'https://')
                  : source.mediasource.mediaurl.replace('http://', 'https://')
              );

              // 오디오 설명 토글 후 비디오 로드 시 1분 미리보기 제한 적용
              const { info } = SbsPlayerGlobal.state.data;
              if (
                info.type === 'VOD3MIN' ||
                info.preview_yn === 'Y' ||
                info.onair_preview_yn === 'Y'
              ) {
                videoElement.video.addEventListener(
                  'loadedmetadata',
                  () => {
                    // * 미리보기 방지
                    const limitDuration = 180;
                    Object.defineProperty(videoElement.video, 'duration', {
                      get: function () {
                        return limitDuration;
                      },
                      configurable: true,
                    });

                    videoElement.video.dispatchEvent(
                      new Event('durationchange')
                    );
                    videoElement.video.addEventListener('timeupdate', () => {
                      if (videoElement.video.currentTime >= limitDuration) {
                        videoElement.video.pause();
                        console.log('++ video-ended');
                        SbsPlayerGlobal.events.emitEvent('video-ended');
                      }
                    });
                  },
                  { once: true }
                );
              }

              this.toastSubtitleSupport();
            }
          } catch (error) {
            console.log(error);
          }
        });
        controlElement.addEventListener(
          'button-toggle-live-dvr',
          async (event) => {
            try {
              this.state.dvr = event.detail;
              SbsPlayerGlobal.state.dvr = this.state.dvr;
              const { media } = await this.request(
                this.state.rscuse,
                false,
                this.state.dvr
              );
              videoElement.loadSource(media);
              videoElement.video.playbackRate = this.playbackRate;

              this.adjustVolume(videoElement);
            } catch (error) {
              console.log(error);
            }
          }
        );
        controlElement.addEventListener(
          'button-toggle-live-caption',
          (event) => {
            this.dispatchEvent(
              new CustomEvent('button-toggle-live-caption', {
                detail: event.detail,
              })
            );
          }
        );
        controlElement.addEventListener(
          'button-toggle-live-caption',
          async (event) => {
            try {
              this.state.cc = event.detail;

              const { media } = await this.request(
                this.state.rscuse,
                this.state.cc,
                this.state.dvr
              );

              videoElement.loadSource(media);
              videoElement.video.playbackRate = this.playbackRate;
              videoElement.video.play();

              this.adjustVolume(videoElement);
            } catch (error) {
              console.log(error);
            }
          }
        );
        controlElement.addEventListener(
          'select-change-quality',
          async (event) => {
            try {
              this.state.rscuse = event.detail;
              const currentTime = videoElement.video.currentTime;

              const { source } = SbsPlayerGlobal.state.data;
              // ! 기존 구매관련 아이디는 일반화질, 고화질 mediarscid 으로만..사용 중
              // * 낮은 화질 순서로 정렬
              const mediasourcelist = source.mediasourcelist.sort((a, b) => {
                return parseInt(a.mediarscuse) - parseInt(b.mediarscuse);
              });

              // ! 23-11-22 결제 시스템에서 VOD는 02/05 화질 코드만 사용하지만, 온에어는 그냥 이용권 구매임으로 예외처리 필요
              const selectedQuality = mediasourcelist.filter((mediasource) => {
                // ! 24-04-11 구매창 오류 수정
                return mediasource.mediarscuse === this.state.rscuse;
              })[0];

              if (selectedQuality.required_payment === 'Y') {
                // * [front-pc] /app/src/js/model/end/common/player.js
                if (SbsPlayerGlobal.target != 'live') {
                  this.dispatchEvent(
                    new CustomEvent('billing-popup', {
                      detail: {
                        type: 'vods',
                        resource: selectedQuality.mediarscid,
                      },
                    })
                  );
                  billingPopup('vods', selectedQuality.mediarscid);
                } else {
                  this.dispatchEvent(
                    new CustomEvent('billing-popup', {
                      detail: {
                        type: 'onair',
                        resource: null,
                      },
                    })
                  );
                  billingPopup('onair', null);
                }

                return false;
              }

              // * 모바일 시나리오 변경(모바일웹에선 초고화질 재생안됨)
              if (
                SbsPlayerGlobal.target !== 'golf' &&
                SbsPlayerGlobal.state.is_mobile &&
                (this.state.rscuse === '07' || this.state.rscuse === '09')
              ) {
                if (confirm('초고화질은 SBS앱에서 이용 가능합니다.')) {
                  SbsPlayerGlobal.events.emitEvent(`applink-clicked`, true);
                }
                return false;
              }

              SbsPlayerGlobal.state.rscuse = this.state.rscuse;
              const { media } = await this.request(
                this.state.rscuse,
                false,
                this.state.dvr
              );

              // ?? track cuechange 이벤트가 안오길래 그냥 기존처럼 다시 렌더링으로 변경?
              videoElement.loadSource(media);
              videoElement.video.playbackRate = this.playbackRate;
              videoElement.video.currentTime = videoElement.video.currentTime;
              videoElement.video.play();

              this.adjustVolume(videoElement);
              qaulityMenuElement.render();
            } catch (error) {}
          }
        );
        motionElement.addEventListener('motion-current', (event) => {
          centerElement.style.display = event.detail ? 'none' : 'block';
        });
        // * input -> publish 로 변경했지만.. 의미상 그대로 사용
        controlElement.addEventListener('input-change-volume', (event) => {
          let value = event.detail;
          let changeVolume = value && clamp(value, 0, 1);
          videoElement.video.volume = changeVolume;
          saveLocalStorage(
            SbsPlayerGlobal.storage.sbsplayer_volume,
            changeVolume
          );
        });
        // * unmute 컴포넌트에서 발생하는 이벤트
        SbsPlayerGlobal.events.addEventListener(
          'input-change-volume',
          (volume) => {
            let changeVolume = clamp(volume, 0, 1);
            videoElement.video.volume = changeVolume;
            saveLocalStorage(
              SbsPlayerGlobal.storage.sbsplayer_volume,
              changeVolume
            );
          }
        );
        SbsPlayerGlobal.events.addEventListener(
          'motion-key-event',
          (status) => {
            // mute, unmute 없네, 라이브 예외처리 필요
            if (SbsPlayerGlobal.target !== 'live')
              motionElement.setAttribute('motion', status);
          }
        );

        SbsPlayerGlobal.events.addEventListener(
          'double-touch-backward',
          (count) => {
            motionElement.setAttribute('motion', 'backward');
            motionElement.setAttribute('count', count);
          }
        );
        SbsPlayerGlobal.events.addEventListener(
          'double-touch-forward',
          (count) => {
            motionElement.setAttribute('motion', 'forward');
            motionElement.setAttribute('count', count);
          }
        );
        SbsPlayerGlobal.events.addEventListener(
          'select-change-speed',
          (event) => {
            let changeValue = event.target ? event.target.value : event;
            this.playbackRate = changeValue;

            // FIXME: [플레이어] 슬로우모션 기능 끄지 않은 상태에서 이탈 시 초기화
            // saveLocalStorage(
            //   SbsPlayerGlobal.storage.sbsplayer_playback_rate,
            //   changeValue
            // );
            videoElement.video.playbackRate = changeValue;
          }
        );

        SbsPlayerGlobal.events.addEventListener('autoplay-failed', () => {
          try {
            console.log('autoplay-failed');
            centerElement.style.display = 'block';

            if (videoElement && videoElement.video) {
              videoElement.video.muted = true;
              videoElement.video.volume = 0;

              const retryPlayPromise = videoElement.video.play();
              retryPlayPromise
                .then(() => {
                  console.log('음소거 상태로 자동 재생');
                })
                .catch((error) => {
                  console.error('음소거 상태에서도 자동 재생 오류:', error);
                });
            }
          } catch (error) {
            console.log(error);
          }
        });
      } catch (error) {
        console.log(error);
      }
    }

    styles() {
      try {
        setTimeout(() => {
          // this.$wapper = SbsPlayerGlobal.view.querySelector('.playerVideo_w');
          // if (window.innerWidth > window.innerHeight) {
          //   if (this.$wapper) this.$wapper.style.height = window.innerHeight + 'px';
          //   if (this.$wapper) this.$wapper.style.paddingTop = '0';
          // }
        }, 500);
      } catch (error) {}
    }

    toast(messages) {
      try {
        if (!messages) return false;
        const toast = this.querySelector('sbs-player-toast');
        if (Array.isArray(messages)) {
          for (let i = 0; i < messages.length; i++) {
            setTimeout(function () {
              toast.message = `${messages[i]} `;
            }, i * 3_500);
          }
        } else {
          toast.message = `${messages} `;
        }
      } catch (error) {
        console.error(error);
      }
    }

    toastSubtitleSupport() {
      const { source } = SbsPlayerGlobal.state.data;
      const toast = this.querySelector('sbs-player-toast');
      if (!this.shownFoundationMessage) {
        toast.message =
          document.documentElement.lang === 'en'
            ? source.toast.message.en
            : source.toast.message.ko;
        this.shownFoundationMessage = true;
      }
    }

    playVideo() {
      try {
        const videoElement = this.querySelector('sbs-player-video');
        const centerElement = this.querySelector('sbs-player-center-buttons');
        centerElement.style.display = 'block';

        setTimeout(() => {
          this.style.display = 'block';
          this.style.opacity = 1;

          // FIXME: [플레이어] 슬로우모션 기능 끄지 않은 상태에서 이탈 시 초기화
          // videoElement.video.playbackRate =
          //   SbsPlayerGlobal.target !== 'live' &&
          //   !SbsPlayerGlobal.state.is_mobile
          //     ? parseFloat(
          //         loadLocalStorage(
          //           SbsPlayerGlobal.storage.sbsplayer_playback_rate
          //         ) || 1
          //       )
          //     : 1;

          videoElement.video.playbackRate = 1;

          // * 재생 시도.
          this.attemptPlayback(videoElement);
        }, 750);

        this.styles();
      } catch (error) {
        console.log(error);
      }
    }

    attemptPlayback(videoElement, isMutedRetry = false) {
      console.log(
        'attemptPlayback',
        videoElement,
        isMutedRetry,
        videoElement.video.paused
      );
      if (!videoElement.video.paused) {
        return false;
      }

      if (
        isMutedRetry &&
        window.navigator.userAgent.match(
          /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
        )
      ) {
        return false;
      }

      let promise = videoElement.video.play();
      if (promise !== undefined) {
        promise
          .then((_) => {
            // 재생 성공 시 볼륨 설정
            if (!isMutedRetry) {
              console.log('자동 재생 성공');
              videoElement.video.muted = false;
              videoElement.video.volume = 0.5;
              videoElement.video.play();

              // 본영상 재생 후 100ms 딜레이로 preroll-ended 이벤트 발생
              setTimeout(() => {
                this.dispatchEvent(
                  new CustomEvent('preroll-ended', {
                    bubbles: true,
                    composed: true,
                    detail: {},
                  })
                );
              }, 100);
            } else {
              videoElement.video.muted = true;
              videoElement.video.volume = 0;
              videoElement.video.play();
              console.log('음소거 상태로 자동 재생 성공');

              // 본영상 재생 후 100ms 딜레이로 preroll-ended 이벤트 발생
              setTimeout(() => {
                this.dispatchEvent(
                  new CustomEvent('preroll-ended', {
                    bubbles: true,
                    composed: true,
                    detail: {},
                  })
                );
              }, 100);
            }
          })
          .catch((error) => {
            console.warn('video play error', error);

            if (!isMutedRetry) {
              // 첫 시도 실패 시 음소거 상태로 재시도
              console.log('자동 재생 실패, 음소거 상태로 재시도합니다');
              videoElement.video.muted = true;
              videoElement.video.volume = 0;
              this.attemptPlayback(videoElement, true);
            } else {
              // 음소거 재시도도 실패한 경우
              console.warn('음소거 상태에서도 재생 실패');
              SbsPlayerGlobal.events.emitEvent('autoplay-failed');
            }
          });
      } else {
        console.log('video not loaded?');
      }
    }

    async play() {
      try {
        const { info } = SbsPlayerGlobal.state.data;
        const videoElement = this.querySelector('sbs-player-video');
        if (
          info &&
          info.onair_preview_yn !== 'Y' &&
          SbsPlayerGlobal.target === 'live' &&
          this.hlsDisposed
        ) {
          console.log('dispose video');

          this.state.cc = false;
          this.state.dvr = false;
          const { media } = await this.request(
            this.state.rscuse,
            this.state.cc,
            this.state.dvr
          );
          videoElement.loadSource(media);
          videoElement.video.playbackRate = this.playbackRate;
          videoElement.video.currentTime = currentTime;
          videoElement.video.play();

          this.adjustVolume(videoElement);
          this.hlsDisposed = false;
        } else {
          console.log('play video');
          videoElement.video.play();
        }
      } catch (error) {
        console.log(error);
      }
    }

    pause() {
      try {
        let { info } = SbsPlayerGlobal.state.data;

        const videoElement = this.querySelector('sbs-player-video');
        videoElement.video.pause();
        console.log('pause video');

        if (
          info &&
          info.onair_preview_yn !== 'Y' &&
          SbsPlayerGlobal.target === 'live'
        ) {
          console.log('video pause hls onair dispose');
          console.log('dispose video');

          this.hlsDisposed = true;

          videoElement.player.destroy();
          videoElement.player.stopLoad();

          clearTimeout(SbsPlayerGlobal.live_midroll.ct_request_timeout);
          clearTimeout(SbsPlayerGlobal.live_midroll.rd_request_timeout);

          SbsPlayerGlobal.events.emitEvent('hls-disposed');
          SbsPlayerGlobal.events.emitEvent('video-change-player', {
            type: 'pause',
          });
        }
      } catch (error) {
        console.log(error);
      }
    }

    destroy() {}
  }
);
